<template>
  <div class="privacy">
    <section class="page-header">
      <div class="container">
        <h1>隐私政策</h1>
        <p>我们重视您的隐私，致力于保护您的个人信息安全</p>
      </div>
    </section>

    <section class="content-section">
      <div class="container">
        <div class="content-wrapper">
          <div class="last-updated">
            <p>最后更新日期：2026年4月12日</p>
          </div>

          <div class="content-block">
            <h2>一、引言</h2>
            <p>本隐私政策适用于广州爱匠文化有限公司（以下简称"我们"、"本公司"）提供的所有产品和服务。我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
          </div>

          <div class="content-block">
            <h2>二、我们如何收集和使用您的个人信息</h2>
            <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。我们仅会出于本政策所述的以下目的，收集和使用您的个人信息：</p>
            
            <h3>1. 注册成为用户</h3>
            <p>为完成创建账号，您需提供以下信息：您的姓名、电子邮箱地址、手机号码、创建的用户名和密码。您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。</p>

            <h3>2. 向您提供商品或服务</h3>
            <p>您向我们提供的信息包括：联系地址、电子邮箱、公司名称等。您使用我们的特定服务时，为满足向您提供产品和服务之目的，除注册时提供的信息外，您还需要进一步向我们提供您的真实姓名、身份信息等。</p>

            <h3>3. 改进我们的服务</h3>
            <p>我们可能将通过某一项服务所收集的信息，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的您的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、而非普遍推送的信息。</p>
          </div>

          <div class="content-block">
            <h2>三、我们如何使用 Cookie 和同类技术</h2>
            <p>为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好或购物篮内的商品等数据。</p>
            <p>我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。</p>
          </div>

          <div class="content-block">
            <h2>四、我们如何共享、转让、公开披露您的个人信息</h2>
            <h3>1. 共享</h3>
            <p>我们不会与其他任何公司、组织和个人分享您的个人信息，但以下情形除外：</p>
            <ul>
              <li>在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
              <li>我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</li>
            </ul>

            <h3>2. 转让</h3>
            <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：</p>
            <ul>
              <li>在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
              <li>在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
            </ul>

            <h3>3. 公开披露</h3>
            <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
            <ul>
              <li>获得您明确同意后；</li>
              <li>基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</li>
            </ul>
          </div>

          <div class="content-block">
            <h2>五、我们如何保护您的个人信息</h2>
            <p>我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。</p>
            <p>我们的数据安全能力：我们采用业界领先的安全技术和程序来保护您的个人信息不被未经授权访问、使用或泄露。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息。</p>
          </div>

          <div class="content-block">
            <h2>六、您的权利</h2>
            <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
            <ul>
              <li><strong>访问您的个人信息</strong>：您有权访问您的个人信息，法律法规规定的例外情况除外。</li>
              <li><strong>更正您的个人信息</strong>：当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。</li>
              <li><strong>删除您的个人信息</strong>：在以下情形中，您可以向我们提出删除个人信息的请求。</li>
              <li><strong>改变您授权同意的范围</strong>：每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。</li>
              <li><strong>个人信息主体注销账户</strong>：您随时可注销此前注册的账户。</li>
            </ul>
          </div>

          <div class="content-block">
            <h2>七、我们如何处理儿童的个人信息</h2>
            <p>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</p>
          </div>

          <div class="content-block">
            <h2>八、本政策如何更新</h2>
            <p>我们的隐私政策可能变更。未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</p>
          </div>

          <div class="content-block">
            <h2>九、如何联系我们</h2>
            <p>如果您对本隐私政策有任何疑问、意见或建议，或者您想要行使您的个人信息权利，请通过以下方式与我们联系：</p>
            <ul class="contact-list">
              <li>公司名称：广州爱匠文化有限公司</li>
              <li>电子邮箱：1002561026@qq.com</li>
            </ul>
            <p>一般情况下，我们将在十五个工作日内回复。</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<style scoped>
.privacy {
  padding-top: 70px;
}

.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 80px 0;
  text-align: center;
}

.page-header h1 {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.page-header p {
  font-size: 1.1rem;
  opacity: 0.9;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

.content-section {
  padding: 60px 0 100px;
  background: #f8f9fa;
}

.content-wrapper {
  background: #fff;
  padding: 60px;
  border-radius: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.last-updated {
  text-align: right;
  color: #999;
  font-size: 0.9rem;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.content-block {
  margin-bottom: 40px;
}

.content-block:last-child {
  margin-bottom: 0;
}

.content-block h2 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #667eea;
  display: inline-block;
}

.content-block h3 {
  font-size: 1.2rem;
  color: #444;
  margin: 25px 0 15px;
}

.content-block p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 15px;
}

.content-block ul {
  margin-left: 20px;
  margin-bottom: 15px;
}

.content-block li {
  color: #666;
  line-height: 1.8;
  margin-bottom: 10px;
}

.contact-list {
  background: #f8f9fa;
  padding: 20px 20px 20px 40px;
  border-radius: 10px;
  margin: 20px 0;
}

.contact-list li {
  margin-bottom: 8px;
}

@media (max-width: 768px) {
  .page-header h1 {
    font-size: 1.8rem;
  }
  
  .content-wrapper {
    padding: 30px 20px;
  }
  
  .content-block h2 {
    font-size: 1.3rem;
  }
}
</style>
